/****************************************************
 * Vue Router for directing traffic to Vue components
 * / home
 * /:orchestration -- chooses component based on passed orchestration name
 ****************************************************/
import { createRouter, createWebHistory } from 'vue-router'
import MainPage from './../components/Main.vue'
import FormOrchestration from '../components/formOrchestration/FormOrchestration.vue'
import { useFormOrchestrationStore } from '../stores/formOrchestration'
import * as cfg from './../config.js'

const showEnvHeader = cfg.SHOW_ENV_HEADER || null;
const finishedLocation = cfg.FINISHED_LOCATION || '/'

const routes = [
  { path: '/', name: 'MainPage', component: MainPage, props: { showEnvHeader: showEnvHeader } },
  { path: '/finished', name: 'finished', beforeEnter() { window.location.href = finishedLocation; return false } },
  { path: '/:orchestration', name: 'FormOrchestration', component: FormOrchestration, props: true },
  { path: '/:pathMatch(.*)*', redirect: '/' }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to) => {
  // The Vue 2 app used hash URLs (/#/passwordReset); keep old bookmarks and links working
  if (to.path === '/' && to.hash.startsWith('#/')) {
    return { path: to.hash.substring(1), replace: true }
  }
  // Unknown orchestration names would render an empty page; send them home
  if (to.name === 'FormOrchestration') {
    const store = useFormOrchestrationStore()
    if (!store.orchestrations.some(o => o.name === to.params.orchestration)) return { path: '/' }
  }
  return true
})

export default router
